var _path, _path2, _g, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 138,
    viewBox: "0 0 169 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165.745 54.2142C170.284 112.022 123.005 138 85.7289 138C48.4529 138 0 106.776 0 73.5215C0 40.2665 8.89774 19.5583 46.3945 6.73499C83.8912 -6.0883 161.207 -3.59392 165.745 54.2142Z",
    fill: "#F9F9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1193 36.4534C82.5644 34.9465 85.6545 34.9465 88.0996 36.4533L120.218 56.2465C121.05 56.7597 121.557 57.6657 121.557 58.6411C121.557 59.7011 120.96 60.6713 120.011 61.1515L84.1095 79.3254L48.2078 61.1515C47.2592 60.6713 46.6616 59.7011 46.6616 58.6411C46.6616 57.6657 47.1684 56.7597 48.0012 56.2465L80.1193 36.4534Z",
    fill: "#B1B0F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.4016 38.5968C51.4016 36.5105 53.0994 34.8192 55.1938 34.8192H112.236C114.331 34.8192 116.029 36.5105 116.029 38.5968V74.7588C116.029 76.8451 114.331 78.5364 112.236 78.5364H55.1938C53.0994 78.5364 51.4016 76.8451 51.4016 74.7588V38.5968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.0713,
    y: 50.4915,
    width: 47.2881,
    height: 4.12426,
    rx: 2.06213,
    fill: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.0713,
    y: 58.74,
    width: 47.2881,
    height: 4.12427,
    rx: 2.06213,
    fill: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.0713,
    y: 66.9885,
    width: 47.2881,
    height: 4.12426,
    rx: 2.06213,
    fill: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.0713,
    y: 42.2429,
    width: 18.1271,
    height: 4.12426,
    rx: 2.06213,
    fill: "#8E8CEE"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6731 59.8302C46.6731 57.0397 49.6057 55.2124 52.1246 56.4334L82.4502 71.1333C83.4977 71.6411 84.7213 71.6411 85.7688 71.1333L116.094 56.4334C118.613 55.2124 121.546 57.0397 121.546 59.8302V95.3802C121.546 97.4665 119.848 99.1578 117.754 99.1578H50.4653C48.3709 99.1578 46.6731 97.4665 46.6731 95.3802V59.8302Z",
    fill: "#B1B0F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1162 75.2262C82.5628 73.7168 85.6562 73.7168 88.1028 75.2262L121.546 95.8584C121.546 97.6806 120.063 99.1578 118.234 99.1578H49.9853C48.156 99.1578 46.6731 97.6806 46.6731 95.8584L80.1162 75.2262Z",
    fill: "#C9C8FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 23.4016,
    y: 8.81921,
    width: 120.627,
    height: 99.7172,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.376471 0 0 0 0 0.635294 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.59ce52ec2eac88d809c28decea4dc7c2.svg";
export { ForwardRef as ReactComponent };